import React, { useEffect } from 'react';
import {RefreshBtn, BackHomeBtn} from './showBtn'

/**
 * 
 * 错误页 404 
 * 
 */
const Error404 = () => {
  return (
    <div className="min-w-680px h-full w-full justify-center flex flex-col items-center select-none">
      <div className="h-200px"></div>
      <p className="text-[#999] text-16px font-medium !mt-66px !mb-60px">
        (⊙o⊙)…你似乎来到了一片荒地，这里曾经很繁华，但现在已荒芜人烟
      </p>
      <div>
        <RefreshBtn />
        <BackHomeBtn />
      </div>
    </div>       
  );
}

export default Error404;